<div style="display: inline-block">
  <button (click)="addToPrimaryMerkliste()" (contextmenu)="showMenu($event)" *ngIf="(mlsvc.primary_merkliste$|async)" [disabled]="disabled"
          mat-button
          matTooltipPosition="left"
          matTooltip="Zur Merkliste '{{(mlsvc.primary_merkliste$|async)?.label}}' hinzufügen. (R-Klick für Auswahl)">
    <svg-icon color="{{disabled ? 'grey' : '#9E24BAFF'}}">in-merkliste</svg-icon>
  </button>
</div>
